module.exports = __webpack_public_path__ + "static/img/LR.d5d14aeb.svg";